import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store/types';
import MemberLoginModal from 'app/common/components/Modals/MemberLoginModal';
import MemberRegisterNSModal from 'app/common/components/Modals/MemberRegisterNSModal';
import IdleModal from 'app/common/components/Modals/IdleModal';

const ModalCollection: React.FC = () => {
  const modalsState = useSelector((state: RootState) => state.UI.modals);
  const authorizationState = useSelector((state: RootState) => state.common.member.authorization);

  return (
    <>
      {/* 閒置 Modal (僅在會員已登入的狀態下啟動) */}
      {modalsState.idleModalVisible && authorizationState && (
        <IdleModal visible={modalsState.idleModalVisible} />
      )}
      {/* 會員登入 Modal */}
      {modalsState.memberLoginModalVisible && (
        <MemberLoginModal visible={modalsState.memberLoginModalVisible} />
      )}
      {/* 網服會員註冊 Modal */}
      {modalsState.memberRegisterNSModalVisible && (
        <MemberRegisterNSModal visible={modalsState.memberRegisterNSModalVisible} />
      )}
    </>
  );
};

export default ModalCollection;
